import styled from "styled-components";

export const StyledSection = styled.div<{
  fullWidth?: boolean;
  backgroundColor?: string;
  padding?: number[];
  margin?: number[];
  zIndex?: number;
}>`
  position: relative;
  width: 100%;
  align-items: center;
  /* BV parity: SPF section.scss sets border-box on .spf-rce-section - theme classes
     (e.g. .objectiveset) apply max-width+padding+border here, and content-box makes
     the box 22px wider than BV, shifting its content 11px left */
  box-sizing: border-box;

  ${(props) =>
    props.backgroundColor
      ? `
    background-color: ${props.backgroundColor};
  `
      : ""}
  ${(props) => `
    padding: ${
      props.padding ? props.padding.map((paddingValue) => `${paddingValue}px`).join(" ") : "initial"
    };
    margin: ${
      props.margin ? props.margin.map((marginValue) => `${marginValue}px`).join(" ") : "initial"
    };
    z-index: ${props.zIndex ? props.zIndex : "initial"};
  `}
`;

const getBackgroundPosition = (direction?: string, speed: number = 1) => {
  switch (direction) {
    case "fixed":
      return `background-attachment: fixed;`;

    case "horizontal":
      return `background-position: calc(50% - var(--scrollProgress)) 50%;
              background-size: calc(100% + (100% * ${speed} /10));`;

    default:
      return `background-position: 50% calc(50% - var(--scrollProgress));
              background-size: calc(100% + (100% * ${speed} /10));`;
  }
};

export const SectionBackgroundWrapper = styled.div<{
  imageURL?: string;
  backgroundColor?: string;
  fullWidth?: boolean;
  readOnly?: boolean;
  defaultStyles?: string;
  parallaxDirection?: string;
  speed?: number;
  disabled?: boolean;
}>`
  margin: 0 auto;

  ${(props) => (props.defaultStyles ? props.defaultStyles : "")}
  background-color: unset;

  ${(props) =>
    props.imageURL
      ? `
    background-image: url(${encodeURI(props.imageURL)});
    background-size: cover;
    background-repeat: no-repeat;
    ${props.parallaxDirection === "fixed" ? `background-attachment: fixed;` : ""}
  `
      : ""}

  ${(props) => !props.disabled && getBackgroundPosition(props.parallaxDirection, props.speed || 1)}

  ${(props) =>
    props.backgroundColor
      ? `
    background-color: ${props.backgroundColor};
  `
      : ""}

  ${(props) =>
    props.fullWidth
      ? `
    max-width: ${props.readOnly ? "100%" : "calc(100% - 40px)"};
    width: 100%;
    padding: 0;
    border: 0;
    border-radius: 0;
  `
      : ""}

  /* narrow-screen width/padding: .stage-responsive rules in index.scss (BV StageContainer) */

  @media (max-width: 450px) {
    .popover-wrapper .spf-rce-section-background-wrapper {
      padding: 0 !important;
      max-width: 100% !important;
    }
  }
`;

export const PaddedSectionContent = styled.div<{
  displayHovered?: boolean;
  fullWidth?: boolean;
  readOnly?: boolean;
}>`
  position: relative;
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: center;
  background-color: unset;

  /* BV parity: PaddedSectionContent gives stage elements a 5px column gutter,
     except in the first column - without it, second-column content sits 5px
     left of BV and its text boxes are 5px wider (different line wrapping) */
  .spf-rce-element {
    margin: 0 0 0 5px;
  }
  .spf-rce-column:first-child .spf-rce-element {
    margin-left: 0;
  }
`;
